import React from 'react';
import Footer from '../footer/Footer';
import useMediaQuery from '@mui/material/useMediaQuery';
import MainHeader from '../header/MainHeader';
import Explore from '../pageComponents/Explore';
import StaticMainHeader from '../StaticHeader/StaticMainHeader';

const MainLayout = () => {
    const vMediaQuery = useMediaQuery('(max-width:600px)');

    const pageContainer = {
        display: "flex",
        flexDirection: "column",
        minHeight: vMediaQuery ? "100vh" : "70vh", // Adjust height for mobile devices
        overflowX: "hidden", // Hide horizontal overflow
    };

    const contentContainer = {
        flex: 1, // Take remaining vertical space
        display: "flex",
        flexDirection: "column",
        paddingRight: vMediaQuery ? 0 : '0px', // Add right padding for larger screens
        overflowY: "auto", // Enable vertical scrolling for content
    };

    const footerStyle = {
        backgroundColor: "#294663",
        color: "#fff",
        width: "100%", // Set width to fill the entire container
        height: "100%"
    };


    return (
        <>
            <StaticMainHeader /> {/* Static header outside of the scrollable content */}
            <div style={pageContainer}>
                <MainHeader />
                <div style={contentContainer}>

                    <Explore />
                </div>
                <div style={footerStyle}>
                    <Footer />
                </div>
            </div>
        </>
    );
}

export default MainLayout;
